<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-col-padding">
	<div [formGroup]="vehicleForm" class="col-container">

		<div class="row">
			<div *ngIf="isMobileView" class="col-xs-12 col-sm-3 col-md-3 col-lg-3 side--nav--column filter-mobile-view"
			[ngClass]="isMobileView === true ? 'model-view-display' : 'model-view'"	#sideNav id="side-nav">
				<div [ngClass]="isMobileView === true ? 'model-view-display' : 'model-view'">
					<button type="button" class="btn close filter-close"
					(click)="toggleScreen()">
						<span aria-hidden="true" class="close&#45;&#45;style">X</span>
					</button>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="margin-top: 0px;margin-bottom: 8px;">
						<div class="col1CompHeader">Model Year</div>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
						<div  class="" style="padding: 0px;margin-right: 14px;">
							<button  class="btn currentBtnStyle"
							[style.background-color]="selectedIndex === 0 ? '#324047' : '#FFFFFF'"
							[style.color]="selectedIndex === 0? '#FFFFFF' : ' #324047'"
							(click)="getVehicleModelForYear(0)"><span class="current--button--label">CURRENT</span>
							</button>
						</div>
						<div  class="" style="padding: 0px;">
							<button class="btn previousBtnStyle" (click)="getVehicleModelForYear(1)"
							[style.background-color]="selectedIndex === 1 ? '#324047' : '#FFFFFF'"
							[style.color]="selectedIndex === 1? '#FFFFFF' : ' #324047'"
							mat-stroked-button><span class="previous--button--label">PREVIOUS</span>
							</button>
						</div>
					</div>

					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="margin-top: 48px;margin-bottom: 19px;">
						<div class="col1CompHeader">Market</div>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 viewBlackLabelChekBox" style="margin-bottom: 20px; border-radius: 0px">
						<mat-checkbox  #checkbox formControlName="isBlackLabel"
						(change)='showBlackLabelOptions(checkbox.checked,selectedIndex)'>
						View Black Label Only
						</mat-checkbox>

						<img data-container="body" height="14px" width="14px"   ngbPopover="{{ToolTipConstants.BLACK_LABEL_TOOLTIP}}"
							 placement="auto"
							 [triggers]="modelPopoverTriggers"
							 autoClose=true
						     class="blacklabeltooltip" src="finance/payment-calculator/assets/image/iball-gray.svg"  alt="..." loading="lazy">
						<hr class="solid">
					</div>
					<br>
				</div>
			</div>

			<div class="overflow-x">
				<div *ngIf="isMainNav"
						[ngClass]="isMobileView === false ? 'col-xs-12 col-sm-11 col-md-12 col-lg-12 mv' : 'col-xs-12 col-sm-7 col-md-7 col-lg-8' " #mainNav id="main-nav">
					<div *ngIf="!isMobileView" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-left filters">
						<a class="vehicle--list" (click)="toggleScreen()">
						<i class="fas fa-filter"></i>
						</a>
						<div class="filter--label">FILTERS</div>
					</div>
					<div [ngClass]="isMobileView === false ? 'model-view-display' : 'model-view'">
						<div class="col2Header">SELECT A LINCOLN VEHICLE</div>
						<div class="banner-wrapper mt-0">
							<div class="show-grid-1 pl-0 align-middle">
								<div class="banner d-in-flex pt-0 pb-0 pr-1 pl-1">
									<p class="banner-text align-middle pl-1 mt-0 mb-0" id="para_Id">Some models, trims, and features may not be available. Contact your dealer for more information.</p>
								</div>
							</div>
						</div>
						<div class=" white-area">
							<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 vehicle--list--style list-unstyled"
								*ngFor="let item of showVehicles;">
								<button type="button"
									(click)="navigateModelTrim(item)"
									(keydown.enter)="navigateModelTrim(item)"
									class="vehicle-select-btn"
								>
									<div class="vehicle-img-width">
										<ul style="list-style: none">
										<li>
											<img width="768" height="425" class="vehicle-image-size1" style="margin-top: 0px; margin-bottom: 0px;"
												 alt="" [src]="'https://build.ford.com/dig/Lincoln/' + item.ModelName + '/' + item.Year + '/HD-TILE/Hero/EXT/4/vehicle.png'"
												 fetchpriority="high"
												 [srcset]="'https://build.ford.com/dig/Lincoln/' + item.ModelName + '/' + item.Year + '/HD-TILE/Hero/EXT/4/vehicle.png 320w, ' +
											   'https://build.ford.com/dig/Lincoln/' + item.ModelName + '/' + item.Year + '/HD-TILE/Hero/EXT/4/vehicle.png 480w, ' +
											   'https://build.ford.com/dig/Lincoln/' + item.ModelName + '/' + item.Year + '/HD-TILE/Hero/EXT/4/vehicle.png 768w, ' +
											   'https://build.ford.com/dig/Lincoln/' + item.ModelName + '/' + item.Year + '/HD-TILE/Hero/EXT/4/vehicle.png 1024w'"
											/>
										</li></ul>
										<div class="list--left">
											<ul style="list-style: none">
											<li class="vehicleYear">{{item.Year}}</li>
											<li class="vehiclemodel">{{item.displayName}}</li>
											<li>
												<div class="horizonal-model-desc"></div>
											</li>
											</ul>
										</div>
										<div class="list--right">
											<ul style="list-style: none">
											<li>Starting
												at {{item.Pricing.Low.BaseMSRP | wholeDollar}}
												<a (click)="$event.stopPropagation()"
												   aria-label="Button that displays a tooltip in various positions"
												   class="msrp--disclosure"
												   mat-raised-button
												   ngbPopover="{{ToolTipConstants.MODEL_TOOLTIP}}"
												   placement="auto"
												   [triggers]="modelPopoverTriggers"
												   autoClose=true
												>
													1
												</a>
											</li>
											</ul>
										</div>
									</div>
									<div class="spacing"></div>
								</button>
								</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

